import { render } from "./Massages.vue?vue&type=template&id=568760d9&scoped=true"
import script from "./Massages.vue?vue&type=script&lang=js"
export * from "./Massages.vue?vue&type=script&lang=js"

import "./Massages.vue?vue&type=style&index=0&id=568760d9&scoped=true&lang=scss"

import exportComponent from "C:\\projects\\balkan-app\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-568760d9"]])

export default __exports__